import React from "react"
import Icon from "app/static/frontend/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"
const RemoveColumnButton = ({ removeColumn, columnIndex, columnId, id }) => (
    <Tooltip label="Remove Column">
        <div>
            <Icon name="minus-circle" onClick={() => removeColumn(id, columnId, columnIndex)} />
        </div>
    </Tooltip>
)

export default RemoveColumnButton
